import { locationDev } from "./services/Servicos";
import { io } from 'socket.io-client';


export const socket = io(locationDev, { autoConnect: false });